import { render, staticRenderFns } from "./DownloadBanner.vue?vue&type=template&id=74f115cd&scoped=true&"
import script from "./DownloadBanner.vue?vue&type=script&lang=js&"
export * from "./DownloadBanner.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBanner.vue?vue&type=style&index=0&id=74f115cd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f115cd",
  null
  
)

export default component.exports